import { Component, ElementRef, Injectable, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import * as FileSaver from "file-saver";
import { constantUrl } from "src/app/Shared/constantUrl";
import { ToWords } from "to-words";
import * as XLSX from "xlsx";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { ReportsService } from "../../_Reports/services/reports.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

declare var $: any;

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Injectable()
@Component({
    selector: "app-lms-receipt-book",
    templateUrl: "./lms-receipt-book.component.html",
    styleUrls: ["./lms-receipt-book.component.scss"],
    standalone: false
})
export class LmsReceiptBookComponent implements OnInit {
  showSpinner = false;
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  dataSource = new MatTableDataSource<any>([]);
  voucherdatefrom: any = new Date();
  voucherdateto: any = new Date();
  ToDateMax: any;
  executiveList: any;
  Branch: any = 0;
  BranchesList: any;
  currentUser: any;
  executive: any = 0;
  SearchApplication_No: any = "";
  SearchLoanAcNo: any = "";
  SelectStatus: any = "All";
  SelectSourceType: any = "";
  partnerDropdown: any;
  SalesExecutiveData: any;
  LeadSourceName: any = "";
  leadSourceDropdown: any;
  list: any;
  selectedAction: any = "view";
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [
    "VoucherId",
    "CaseNo",
    "Voucher_Date",
    "Voucher_Type",
    "Voucher_ReceiptNo_Book",
    "customer_name",
    "Branch_Name",
    "SourceType",
    "SourceName",
    "Amount",
    "Installment_Amount",
    "Interest_Overdue_Amount",
    "Other_Amount",
    "Account_Name",
    "Collection_By",
    "User_Name",
    "CollectionExecutive",
    "Voucher_CreateOn",
    "Mode_of_Payment",
    "Ref_No",
    "Voucher_Narration",
    "Location",
  ];

  JsonData: any;
  TableData: any[] = [];
  batch: any[] = [];
  CompanyInformation: any;
  AmountInWord = "";
  CompanyProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  CompanyLogoUrl: any = constantUrl.OthersDocUrl;
  private dataCache = new Map<number, any[]>(); 
  pageSize = 1000;
  totalRecords = 0;
  currentPage = 0;
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private losService: LosService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private router: Router,
    private route: ActivatedRoute,
    private LmsService: LmsService,
    private reportsService: ReportsService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Receipt Book");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.BindExecuite();
    this.getBranchesList();
    this.getLeadSourceDropdown();
    this.Get_PartnerForDropdown();
    this.onFromDateChange();
  }
  async loadReceiptBookList() {
    const payload = {
      From: this.voucherdatefrom,
      To: this.voucherdateto,
      CollectionExecutive: this.executive,
      Branch_Id: this.Branch,
      Application_No: this.SearchApplication_No,
      LoanAcNo: this.SearchLoanAcNo,
      SourceType: this.SelectSourceType || "",
      Status: this.SelectStatus,
      SourceId: this.LeadSourceName || 0,
      LoginUserId: this.currentUser.userId,
    };
    
    this.loadReceiptBook(payload);
  }

  // async loadReceiptBook(payload) {
  //   var records = [];  // reset results

  //   await this.LmsService.ReceiptBookDataNew((row) => {
  //     console.log("Streamed Row:", row);
  //     records.push(row);
  //     this.dataSource.data = [...this.dataSource.data, row];
  //   }, payload);
  //   this.showSpinner = false;
  // }

  async loadReceiptBook(payload) {
    this.batch = [];
    this.dataSource.data = [];

    let receivedAny = false;

    await this.LmsService.ReceiptBookDataNew((row) => {
      receivedAny = true;
      this.batch.push(row);

      // Update table every 100 rows
      if (this.batch.length >= 100) {
        this.totalRecords = this.batch[0].TotalData;
        this.appendToTable(this.batch);
        this.showSpinner = false;

        
        //this.scrollToBottom();

        this.batch = [];
      }
      if(this.totalRecords<=100){
         this.showSpinner = false;
      }
    }, payload);

    // last rows
    if (this.batch.length > 0) {
      this.appendToTable(this.batch);
    }
    this.showSpinner = false;

    // no data at all -> show snackbar
    if (!receivedAny) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No Data Found.",
        ...this.configSuccess,
      });
    }
  }

  appendToTable(rows: any[]) {
    this.dataSource.data = [...this.dataSource.data, ...rows];

    setTimeout(() => this.scrollToBottom(), 20);
  }

  scrollToBottom() {
    const el = this.tableContainer.nativeElement;
    el.scrollTop = el.scrollHeight;
  }
  getBranchesList() {
    this.LmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe(
      (result) => (this.BranchesList = JSON.parse(JSON.stringify(result)))
    );
  }
  // scrollToBottom() {
  //   const el = this.scrollContainer.nativeElement;
  //   el.scrollTop = el.scrollHeight;
  // }
  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      this.showSpinner = false;
    });
  }

  Get_PartnerForDropdown() {
    if (
      this.SelectSourceType == "Agent" ||
      this.SelectSourceType == "DSA" ||
      this.SelectSourceType == "Dealer"
    ) {
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.SelectSourceType,
          branchId: 0,
        })
        .subscribe((res: any) => {
          this.partnerDropdown = res;
        });
      this.LeadSourceName = 0;
    } else if (
      this.SelectSourceType == "Sales Executive" ||
      this.SelectSourceType == "Telecaller Executive" ||
      this.SelectSourceType == "Marketing Executive"
    ) {
      this.partnerDropdown = [];
      this.SalesExecutiveData?.forEach((obj: any) => {
        this.partnerDropdown.push({
          PartnerId: obj.EmpId,
          Partner_Name: obj.EmpName,
        });
      });
      this.LeadSourceName = 0;
    } else {
      this.LeadSourceName = "";
    }
  }

  BindExecuite() {
    this._MasterService
      .Get_Employee_ByBranch_Department({
        BranchId: 0,
        DeptId: 0,
        LoginUserId: this.currentUser.userId,
        Type: "Lower",
      })
      .subscribe((res: any) => {
        this.executiveList = res;
      });
  }

  getThreeMonthsLaterDate(dateInput: any): Date {
    if (!dateInput) return null;
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) return null;
    const targetMonth = d.getMonth() + 3;
    const result = new Date(d);
    result.setMonth(targetMonth);
    if (result.getMonth() !== targetMonth % 12) {
      result.setDate(0);
    }
    return result;
  }

  onFromDateChange() {
    if (this.voucherdatefrom) {
      const fromDate = new Date(this.voucherdatefrom);
      if (!isNaN(fromDate.getTime())) {
        const maxToDate = this.getThreeMonthsLaterDate(fromDate);
        const today = new Date();
        this.ToDateMax = maxToDate > today ? today : maxToDate;
        this.voucherdateto = this.ToDateMax;
      }
    }
    this.DateChange();
  }

  DateChange() {
    if (!this.voucherdatefrom || !this.voucherdateto) {
      return;
    }

    const fromDate = new Date(this.voucherdatefrom);
    const toDate = new Date(this.voucherdateto);

    if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
      return;
    }

    const fromTime = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()).getTime();
    const toTime = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate()).getTime();

    if (toTime < fromTime) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Date To cannot be less than Date From.",
        ...this.configSuccess,
      });
      const maxToDate = this.getThreeMonthsLaterDate(fromDate);
      const today = new Date();
      this.ToDateMax = maxToDate > today ? today : maxToDate;
      this.voucherdateto = this.ToDateMax;
      return;
    }

    const maxAllowedToDate = this.getThreeMonthsLaterDate(fromDate);
    const today = new Date();
    const effectiveMax = maxAllowedToDate > today ? today : maxAllowedToDate;
    const effectiveMaxTime = new Date(effectiveMax.getFullYear(), effectiveMax.getMonth(), effectiveMax.getDate()).getTime();

    if (toTime > effectiveMaxTime) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Date cannot be beyond today or more than 3 months from start date.",
        ...this.configSuccess,
      });
      this.voucherdateto = effectiveMax;
      this.ToDateMax = effectiveMax;
    }
  }

  // ✅ Modified search function
  onsearch() {
    this.showSpinner = true;
    this.currentPage = 0;
    this.dataCache.clear();
    //this.loadPageData(this.currentPage);
    this.loadReceiptBookList();
  }

  loadPageData(pageIndex: number) {
    this.showSpinner = true;

    // check cache first
    if (this.dataCache.has(pageIndex)) {
      this.dataSource.data = this.dataCache.get(pageIndex);
      this.showSpinner = false;
      return;
    }

    const payload = {
      From: this.voucherdatefrom,
      To: this.voucherdateto,
      CollectionExecutive: this.executive,
      Branch_Id: this.Branch,
      Application_No: this.SearchApplication_No,
      LoanAcNo: this.SearchLoanAcNo,
      SourceType: this.SelectSourceType || "",
      Status: this.SelectStatus,
      SourceId: this.LeadSourceName || 0,
      LoginUserId: this.currentUser.userId,
      //PageNumber: pageIndex + 1,
      // PageSize: this.pageSize,
    };

    this.LmsService.ReceiptBookData(payload).subscribe(
      (res: any) => {
        if (res?.length > 0) {
          console.log("res", res);
          this.dataCache.set(pageIndex, res);
          this.dataSource.data = res;

          const firstItem = res[0];
          if (firstItem && firstItem.TotalData !== undefined) {
            this.totalRecords = firstItem.TotalData;
          } else {
            this.totalRecords = res.length;
            console.warn("TotalData property not found in response");
          }
        } else {
          this.dataSource.data = [];
          this.totalRecords = 0;
          if (pageIndex === 0) {
            // Only show message on first page
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "No data found",
              ...this.configSuccess,
            });
          }
        }
        this.showSpinner = false;
      },
      (error) => {
        console.error("Error loading data:", error);
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Error loading data",
          ...this.configSuccess,
        });
      }
    );
  }

  // ✅ When paginator changes
  onPageChange(event: PageEvent) {
    //this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadPageData(this.currentPage);
  }

  // Excel export
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(
      data,
      excelFileName + new Date().getTime() + EXCEL_EXTENSION
    );
  }
  handleAction() {
    if(this.selectedAction==""){
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please select an action",
        ...this.configSuccess,
      });
    }
  else if (this.selectedAction === "view") {
    this.onsearch();
  } 
  else if (this.selectedAction === "export") {
    this.exportExcel();
  }

  // Optional: Reset dropdown back to default
  // this.selectedAction = "";
}

  exportExcel() {
    this.showSpinner = true;
    this.LmsService.ExportReceiptBook({
      From: this.voucherdatefrom,
      To: this.voucherdateto,
      CollectionExecutive: this.executive,
      Branch_Id: this.Branch,
      Application_No: this.SearchApplication_No,
      LoanAcNo: this.SearchLoanAcNo,
      SourceType: this.SelectSourceType || "",
      Status: this.SelectStatus,
      SourceId: this.LeadSourceName || 0,
      LoginUserId: this.currentUser.userId,
    }).subscribe((blob: Blob) => {
      if (blob) {
        this.showSpinner = false;
        const a = document.createElement("a");
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = "ReceiptBook.xlsx";
        a.click();
        URL.revokeObjectURL(objectUrl);
      }
    });
    // this.JsonData.forEach((obj: any) => {
    //   delete obj.Id;
    //   delete obj.VoucherId;
    //   delete obj.ChagesHead;
    //   delete obj.Voucher_Total_Tax;
    //   delete obj.Voucher_Tag;
    //   delete obj.Voucher_CreateOn;
    //   delete obj.CustomerId;
    //   delete obj.Loan_Id;
    //   delete obj.Voucher_Cheque_No;
    // });
    // this.exportAsExcelFile(this.JsonData, "Receipt-Book");
  }

  onclick_Receipt(row) {
    this.LmsService.GSTReceiptDetails({
      LoanId: row.Loan_Id,
      VoucherId: row.VoucherId,
    }).subscribe((result: any) => {
      this.CompanyInformation = result.Item1[0];
      this.TableData = result.Item2.filter(
        (originalData) => originalData.TranType == "CR"
      );
      this.AmountInWord = new ToWords().convert(
        parseInt(this.totaltypewisemodal("Total"))
      );
      $("#ReceiptPrint").modal("show");
      $("#ReceiptPrint").css("z-index", "1050");
    });
  }
  

  totaltypewisemodal(row): string {
    if (this.TableData != null) {
      let sum = 0;
      for (let i = 0; i < this.TableData.length; i++) {
        sum += Number(this.TableData[i][row]);
      }
      return sum > 0 ? sum.toFixed(2) : "0";
    }
    return "0";
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  OnCloseVoucherModel() {
    $("#ReceiptPrint").modal("hide");
  }
  PrintDoc(divName, Header) {
    let printContents, popupWin;
    printContents = document.getElementById(divName).innerHTML;
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css">
          <style>
        
     

          @media print {
            @page {
              
                size: A4;
                margin: 10px 20px 20px 20px; 
                content: counter(page) "/" counter(pages);

         
             
              
            }
            #foot {
              content: counter(page) "/" counter(pages);
              counter-increment: page;
            }
            .mt-2 {
              margin-top: 0.5rem !important;
            }
            
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  font-family: "Ubuntu", sans-serif;
}

.invoice {
  margin-top:35px;
  max-height: 100%;
  max-width: 100%;
  // margin: 0 auto;
  /* padding: 10px; */
  border: 2px solid black;
  color:black;
}

 .header {
  background-color: lightblue;
  height: 40px;
  border-bottom: 1px solid black;
  
} 

.header h2 {
  text-align: center;
  margin:0px;
  font-weight: 500;
}
   




.company-info {
  /* display: flex; */
  padding: 5px;
  margin: 0;
  border-bottom: 1px solid #000000;
  height: 180px
}
  
  
  
.info {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -10px;
  margin-left: 130px;
}

.company-name {
  text-align: center;
  word-wrap: normal;
  white-space: nowrap;
  word-break: keep-all;
  font-weight: bold;
  font-size: 24px;
  margin-right: 110px;
  margin-top: 10px;
  margin-bottom: 0px;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  
}
.company-details{
  text-align: center;
  display: flex;
  flex-direction: column;
  position: relative;
  // margin-right: 20px;
  top: 2px;
  right: 65px;
  
 
}
.logo {
  margin-top: 40px;
  // margin-left: 10px;
  position: absolute;
  top: 59px;
}

.logo img {
  max-height: 50px;
}

.party-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px;
  border-bottom: 1px solid black;
  justify-content: start;
}
.party-details{
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-right: 1px solid black;
  padding-right: 340px;
}

.invoice-details{
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom:0px;

}
.invoice-no{
  display: flex;
  justify-content: space-between;

}
.invoice-details p {
  text-align: right;
 
}

.invoice-table {
  width: 100%;
  border-collapse: collapse;
  /* margin-bottom: 20px; */
}

.invoice-table th,
.invoice-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: right;
  width: 56.72px;
}

.invoice-table th {
  background-color: #f0f0f0;
}
.Total-Amount{
  /* width:800px;
  height:70px;
  border:1px solid black; 
  margin: 40px; 
  position: absolute;
  left: 240px; */
  margin-bottom: 50px;
}
.amount{
  text-decoration: underline;
  margin:5px;
}

.footer{
  position:relative;
  top:5px;
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  padding:10px;
  align-items: end;
}
.created{
  display:flex;
  flex-direction: column;
  justify-content: flex-end;
  width:950px;
  /* margin: 15px; */
  position: relative;
  top:50px;
  
}

/* .created span{
  margin:10px;
} */


.signature{
  display: flex;
  flex-direction: column;
  align-items: end;
  position: relative;
  bottom: 10px;
}
 

#createdOn{
  margin-top:15px;
  margin-bottom: 15px;
}

#sign{
  margin-top:30px;
  margin-left:0px;
}
         
          </style>
        </head>
        <body onload="window.print(); window.close()">${printContents}
        <footer></footer>
        </body>
      </html>`);
    popupWin.document.close();
  }
}
